// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1A018","label":"Labeled_label__3Ms3B","divider":"Labeled_divider__2ZhW1"};